module.exports = __webpack_public_path__ + "img/30.ae94b851.jpg";